export default "__VITE_PUBLIC_ASSET__a0e35ee6__"